import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import SensorTypeTableDto from '../dto/SensorTypeTableDto';

class SensorTypeTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'sensorTypeTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<SensorTypeTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, SensorTypeTableDto)))
				.catch(reject);
		});
	}
}

export default new SensorTypeTableService();
